<template>
	<p-feature-flag
		name="Accounting"
		redirect>
		<p-search-screen
			title="Stock Ledger"
			api-destination="stockledgers"
			ref="searchScreen"
			:filters="filters"
			:fields="fields"
			:filter-by="filterBy"
			@total-rows-changed="getTotalRows"
		>
		<template v-slot:actionButtons>
					<p-button
						variant="outline-primary"
						v-on:click="printScreen()"
						:disabled="totalRows <= 0 "
						>Print
					</p-button>
					<p-button
						variant="outline-primary"
						@click="downloadFile('csv')"
						:is-busy="isBusy"
						:disabled="totalRows <= 0 || isBusy">Export (CSV)
					</p-button>
		</template>
			<template v-slot:belowSearch>
				<b-row>
					<b-col cols="3">
							<p-datepicker label="Start Date"
								v-model="filters.startDate"
								vid="reportStartDate" />
							</b-col>
						<b-col cols="3">
							<p-datepicker label="End Date"
								vid="endDate"
								is-end-date
								rules="dateGreaterOrEqual:@reportStartDate"
								v-model="filters.endDate" />
						</b-col>
				</b-row>
			</template>
		</p-search-screen>
	</p-feature-flag>
</template>

<script>
import { datetimeToLocalTimeFormatter, currencyFormatter } from '../../components/Common/Formatters.js';
import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
	mixins: [SearchStorage],
	props: {
		customers: Object,
		account: Object
	},
	methods: {
	getTotalRows(value){
		this.totalRows=value
		},
		printScreen(){
			window.print();
		},
		dccFormatter(value) {
			return value.padStart(6, '0'); // Fixes DCCs like 030101 which would otherwise be displayed as 30101
		},		
		async downloadFile(exportFormat)
		{
		let apiUrl = 'StockLedgers/csv';
			this.isBusy = true;
			axios
				.post(
					apiUrl,
					this.filters,
					{ responseType: 'blob' }
				)
                .then(result => {
					downloadFileToBrowser(
						result.data,
						exportFormat == 'pdf' ? `Stock Ledger` : `Stock Ledger.csv`,
						exportFormat == 'pdf' ? 'application/pdf' : 'application/csv'
					);
					this.$appSuccess(
							`Stock Ledger report generated successfully.`
						)
				})
				.finally(() => {
					this.isBusy = false;
				});
		}
	},
	data() {
		return {			
			filterName: 'TransactionsFilter',
			selectedCustomers: [],
			isBusy: false,
			totalRows:0,
			filters: {
				automatic: null,
				searchBy: 'All',
				startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
				endDate: new Date(),
				sortBy: 'createDate',
				sortDesc: true,
				perPage: 50,
				locationId: null
			},
			filterBy: [
				'All',
				'Entry Type',
				'SKU',
				'Entry Reference',
				'DCC'],
			fields: [			
				{
					label: 'Location',
					key: 'locationName',
					sortable: true
				},
				{
					label: 'Accounting Date',
					key: 'accountingDate',
					sortable: true
				},
				{
					label: 'User Name',
					key: 'userName',
					sortable: true
				},
				{
					label: 'GL Code',
					key: 'glCode',
					sortable: true,
				},
				{
					label: 'Entry Type',
					key: 'entryType',
					sortable: true,
				},
				{
					label: 'Entry Reference',
					key: 'entryReference',
					sortable: true
				},
				{
					label: 'SKU',
					key: 'sku',
					sortable: true,
				},
				{
					label: 'DCC',
					key: 'dcc',
					sortable: true,
					formatter: this.dccFormatter					
				},			   
				{
					label: 'SOH Changed',
					key: 'sohChanged',
					sortable: true
				},
				{
					label: 'Retail',
					formatter: currencyFormatter,
					key: 'retail',
					sortable: true,
					tdClass: 'text-center'
				},
				{
					label: 'Cost',
					formatter: currencyFormatter,
					key: 'cost',
					sortable: true,
					tdClass: 'text-center'
				},
				{
					label: 'Entry Date',
					key: 'createDate',
					formatter: datetimeToLocalTimeFormatter,
					sortable: true,
					sortByformatted: true
				}
			]
		};
	},
	mounted : async function() {
		this.filters.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
	},};
</script>
